import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: () => import('../views/Framework.vue'),
      children: [
        { path: '', name: '首页', component: () => import('../views/Index.vue') },
        { path: 'passport/:action', name: '登录/注册', component: () => import('../views/passport/Passport.vue') },
        { path: 'passport', name: '登录', component: () => import('../views/passport/Passport.vue') },
        {
          path: 'center',
          component: () => import('../views/center/Index.vue'),
          children: [
            { path: '', name: '企业中心', component: () => import('../views/center/Base.vue') },
            { path: 'base', name: '企业中心1', component: () => import('../views/center/Base.vue') },
            { path: 'auth', name: '审核信息', component: () => import('../views/center/Auth.vue') },
            { path: 'safe', name: '安全中心', component: () => import('../views/center/Safe.vue') }
          ]
        },
        { path: '/publish', name: '发布职位', component: () => import('../views/job/Publish.vue') },
        { path: '/job', name: '职位管理', component: () => import('../views/job/List.vue') },
        { path: '/job/:id', name: '职位预览', component: () => import('../views/job/View.vue') },
        { path: '/resume', name: '简历管理', component: () => import('../views/resume/List.vue') },
        { path: '/resume/:id', name: '简历预览', component: () => import('../views/resume/View.vue') }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js